module.exports = __webpack_public_path__ + "static/media/29BDOS3.f3a43f9a.jpg";